//Bootstrap Native
require("./boostrap.native");
require('alpinejs');

import Modal from "bootstrap.native/dist/components/modal-native.esm";

// custom scripts
import lazyImages from "./lazyImages/lazyImages";
import loadStylesheet from "./loadStylesheet";
import loadAutocomplete from "./loadAutocomplete";
import loadJavascriptFile from "./loadJavascriptFile";

// import "./image-selection-tool.js";


// Lazy Images
let images = document.querySelectorAll("img.lazy-img");
if (images.length) lazyImages(images, null);


/**
 * Load Carousel script if carousel is present.
 */
let carousel = document.querySelector(".swiper");
let desktopOnlyCarousel = document.querySelector(".il-desktop-only-swiper");
if (!!carouselScript) {
    if (!!carousel || (desktopOnlyCarousel && window.innerWidth > 767)) {
        loadJavascriptFile(carouselScript);
    }
    if (desktopOnlyCarousel && window.innerWidth <= 767) {
        let images = desktopOnlyCarousel.querySelectorAll(".carousel-lazy-img");
        lazyImages(images);
    }
}

/**
 * Covid Modal
 */
// let covidModalTrigger = document.querySelector("#il-covid-modal-trigger");
// if (covidModalTrigger) new Modal(covidModalTrigger);

/**
 * Login Modal
 */
let loginTriggers = document.querySelectorAll(".loginTrigger");
let modalContainer = document.getElementById("modal-login");

if (!!loginTriggers && modalContainer) {
    let hiddenInputs = document.querySelectorAll('.login-hidden-inputs');

    loginTriggers.forEach(element => {
        let contactModal = new Modal(element);

        // showLoginForm set in master.blade.php
        if (showLoginForm) {
            loadStylesheet();
            contactModal.show();
        }

        modalContainer.addEventListener("show.bs.modal", e => {

            // focus on email field when modal pops up.
            setTimeout(() => {
                document.querySelector('#email').focus();
            }, 450);

            let btnType = !!e.relatedTarget ? e.relatedTarget.dataset.button : null;

            if (btnType) {
                hiddenInputs.forEach(input => input.value = false);
                let input = document.getElementById(btnType);
                input.value = true;
            }
        });
        modalContainer.addEventListener("hide.bs.modal", e => {
            hiddenInputs.forEach(input => input.value = false);
        });
    });
}

/**
 * Virtual Tours
 */
let virtualTours = document.querySelectorAll(".il-tour-embed");

function tourOnClick(e) {
    this.innerHTML = this.dataset.tourVideo;
    this.removeEventListener("click", tourOnClick);
}

virtualTours.forEach(tour => {
    tour.addEventListener("click", tourOnClick);
});

/**
 * Add Stylesheet
 */
let mainNavHam = document.getElementById('il-nav-hamburger');

const addStylesheet = () => {
    window.removeEventListener('scroll', addStylesheet);
    mainNavHam.removeEventListener('click', addStylesheet);

    loadStylesheet();
};

window.addEventListener('scroll', addStylesheet);
mainNavHam.addEventListener('click', addStylesheet);

/**
 * Add Autocomplete Script
 */
let autocompleteInput = document.getElementById('static-autocomplete') || null;

if (autocompleteInput) {
    autocompleteInput.addEventListener('focus', e => {
        loadAutocomplete();
    });
}

/**
 * Permit Modal
 */
let permitTriggers = document.querySelectorAll('.permit_trigger');
let modalPermit = document.getElementById('modal-permit');

if (modalPermit) {
    modalPermit.addEventListener("show.bs.modal", e => {
        loadStylesheet();
    });
}

if (permitTriggers.length) {
    permitTriggers.forEach(element => {
        new Modal(element);
    })
}

/**
 * Add Image Select Download Script
 */
let imageSelectDownload = document.getElementById('image-select-download');

if (imageSelectDownload) {
    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadJavascriptFile(imageSelectDownloadScript);
                observer.unobserve(entry.target);
            }
        });
    });

    observer.observe(imageSelectDownload);
}

// define function globally to be able to attach to any image and make it
// accessible to the react image-select-download component
function sendEvent(element) {
    console.log({
        location_id: element.dataset.locationId,
        location_title: element.dataset.locationTitle,
        location_slug: element.dataset.locationSlug,
        id: element.dataset.id,
        src: element.dataset.src,
    } );
    const event = new CustomEvent('selectableBtnClicked', {
        detail: {
            location_id: element.dataset.locationId,
            location_title: element.dataset.locationTitle,
            location_slug: element.dataset.locationSlug,
            id: element.dataset.id,
            src: element.dataset.src,
        }
    });
    window.dispatchEvent(event);
}

// Make the function globally accessible
window.sendEvent = sendEvent;
